import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Donate } from '@shared/interfaces/cart/donate.interface';
import { BaseCartComponent } from '../../layouts/logged/pages/cart/components/base-cart.component';
import { PhDropComponent } from '@shared/components/ph-drop/ph-drop.component';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { Config } from '@shared/config';
import { RoutesPath } from '@shared/routes-path';
import { PhInputComponent } from '@shared/components/ph-input/ph-input.component';
import { CartService } from '@layouts/default/layouts/logged/pages/cart/cart.service';
import { Response } from '@shared/models/response.model';
import { CurrencyRate } from '@shared/interfaces/cart/currencyRate.interface';
import { Project } from '@shared/models/project.model';
import { ProjectStatus } from '@shared/interfaces/project/project.interface';
import { FacebookPixelService } from '@shared/services/facebook-pixel.service';

@Component({
  selector: 'app-cart-donations',
  templateUrl: './cart-donations.component.html',
  styleUrls: ['./cart-donations.component.scss'],
})
export class CartDonationsComponent extends BaseCartComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup = new UntypedFormGroup({});
  rates: CurrencyRate[] = [];
  currencyList: any = [
    {
      values: [10, 15, 20],
      name: 'zł',
      curr: 'PLN',
      operator: 'TPAY',
    },
    {
      values: [3, 5, 10],
      name: "$",
      curr: "USD",
      operator: 'PAYPAL',
    },
  ];
  currencyPicked: string = 'PLN';
  donatesButtons: any = [
    { val: 3, currency: "USD" },
    { val: 5, currency: "USD" },
    { val: 10, currency: "USD" },
    { val: 10, currency: "PLN" },
    { val: 15, currency: "PLN" },
    { val: 20, currency: "PLN" },
  ];
  customRadioDonate: boolean = false;
  currentValueSetDonate: UntypedFormControl = null;
  @Input() project: Project;
  @Input() eventCategory: boolean;
  @Input() operators: any;
  @Input() actionsVisibility: boolean = true;
  @Input() buttonSmall: boolean = false;
  @Input() projectId: number;
  @Input() currency: string;
  @Input() initValue: number;
  @Output() amountChange: EventEmitter<any> = new EventEmitter();
  @Output() currencyChange: EventEmitter<any> = new EventEmitter();
  timerChangeDonateInput: any;
  enumProjectStatus: any = ProjectStatus;
  disableBtns: boolean = false;
  formInvalid: boolean = true;
  currencyValue: string;
  donation: number;
  @ViewChild('cartDonationDrop')
  cartDonationDrop: PhDropComponent;
  @ViewChild('cartRadios')
  cartRadios: PhInputComponent;

  resizeSubject: any = new Subject<number>();
  resizeObservable: any = this.resizeSubject.asObservable().pipe(throttleTime(50));
  screenWidth: number;

  @HostListener('window:resize', ['$event.target.innerWidth'])
  onResize(width: number) {
    this.resizeSubject.next(width);
    this.screenWidth = width;
  }

  displayContactModal: boolean = false;
  availableOperatorsList: any[] = [];

  constructor(
    public cartService: CartService,
    private readonly _facebookPixelService: FacebookPixelService
  ) {
    super();
    this.getRates();
  }

  get initValueInput() {
    return null;
    // return this.initValue;
  }

  get notRadioBtns() {
    return this.initValue !== 5 && this.initValue !== 3 && this.initValue !== 1;
  }

  runFBPixel() {
    (window as any).fbq('track', 'AddPaymentInfo');
  }

  ngOnInit() {
    if (this.notRadioBtns) {
      this.form.value.donate = this.initValue;
    }
    this.screenWidth = window.innerWidth;
    this.form.addControl('currentCurrency', new UntypedFormControl(this.currencyPicked));

    this.resolveCurrencyByLang();
    const langSub = this.languageService.languageEmitter.subscribe((el) => {
      this.resolveCurrencyByLang();
    });
    this.someSubscriptions.add(langSub);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.operators) {
      this.recomputeAvailableOperators();
    }
  }

  private recomputeAvailableOperators() {
    this.availableOperatorsList = this.currencyList.filter(el => this.isInOperators(el.operator));
  }

  resolveCurrencyByLang() {
    const lang = this.storage.get('lang');
    const currencies = {
      pl: 'PLN',
      en: 'USD',
      es: 'USD',
      pt: 'USD',
      fr: 'USD',
      ua: 'PLN',
      ro: 'USD',
      sk: 'USD',
      de: 'USD',
    };

    let pickedCurrency = lang ? currencies[lang] : currencies.en;
    const selectedCurrencyObj = this.currencyList.find(c => c.curr === pickedCurrency);
    const isAllowed = selectedCurrencyObj && this.operators?.includes(selectedCurrencyObj.operator);

    if (!isAllowed) {
      const firstAllowed = this.currencyList.find(c => this.operators?.includes(c.operator));
      if (firstAllowed) {
        pickedCurrency = firstAllowed.curr;
      }
    }

    this.currencyPicked = pickedCurrency;

    const ctrl = this.form.get('currentCurrency');
    if (ctrl) {
      ctrl.setValue(pickedCurrency, { emitEvent: false });
    }
    this.currencyChange.emit(pickedCurrency);
    return pickedCurrency;
  }

  getRates() {
    const subCurrenciesRates = this.cartService
      .paymentCurrenciesRates()
      .subscribe((el: Response<CurrencyRate[]>) => {
        this.rates = el.data;
      }, this.onCurrenciesRatesError.bind(this));
    this.someSubscriptions.add(subCurrenciesRates);
  }

  onCurrenciesRatesError(error: Error) {
    this.toast.error(
      this.translate.instant('PAYMENT.cant_get_currencies_rates'),
      this.translate.instant('PAYMENT.currencies_error')
    );
  }

  projectOnList(ids: Array<number>) {
    return !!ids.filter((id) => this.router.url.search(id.toString()) > 0).length;
  }

  transformCurrency() {
    this.reduceChain(1300, this.form.value.donate + '');
    const subTransformCurrency = this.resizeObservable.subscribe((width) => {
      this.reduceChain(width, this.form.value.donate + '');
    });
    this.someSubscriptions.add(subTransformCurrency);
  }

  reduceChain(width: number, value: string) {
    if (value !== 'undefined' && width > 767) {
      this.currencyValue = value.length > 4 ? value.substr(0, 4) + '..' : value;
    } else {
      this.currencyValue = value.length > 2 ? value.substr(0, 2) + '..' : value;
    }
  }

  acceptDonateType(event) {
    const currentButtons = this.donatesButtons.filter(
      (item) => item.currency === this.currencyPicked
    );
    if (
      event.value.length > 0 &&
      (+event.value === currentButtons[2] ||
        +event.value === currentButtons[1] ||
        +event.value === currentButtons[0])
    ) {
      this.customRadioDonate = false;
      this.disableBtns = false;
      this.form.get('donate') && this.form.get('donate').setValue(+event.value);
    } else if (event.value.length > 0) {
      setTimeout(() => {
        this.cartRadios.uncheckedAllRadio();
        this.disableBtns = !(+event.value > 0);
        this.form.get('donate').setValue(+event.value);
        this.customRadioDonate = true;
        this.resizeSubject.next(window.innerWidth);
      });
    } else {
      this.customRadioDonate = false;
      this.disableBtns = false;
      this.form.get('donate').setValue(currentButtons[0]);
    }
    this.transformCurrency();
  }

  changeDonateInput(event) {
    if (this.loading || this.formInvalid) {
      return;
    }
    if (
      +event.value === 0 ||
      +event.value > Config.MAXIMAL_PAY_COUNT ||
      event.value.search(',') > 0 ||
      event.value.search('.') > 0
    ) {
      this.toast.error(
        this.translate.instant('CART.error_input_part1') +
          Config.MAXIMAL_PAY_COUNT +
          '. ' +
          this.translate.instant('CART.error_input_part2'),
        this.translate.instant('CART.cart_error')
      );
      return;
    }
    this.acceptDonateType(event);
    if (this.timerChangeDonateInput !== null) {
      clearTimeout(this.timerChangeDonateInput);
    }
    this.timerChangeDonateInput = setTimeout(() => {
      this.amountChange.emit(this.form.value.donate);
    }, 1000);
  }

  saveSetValue(event: UntypedFormControl) {
    const minimum = 1;

    if (
      event.value.indexOf(',') > 0 ||
      event.value.indexOf('.') > 0 ||
      event.value.length > 4 ||
      +event.value > 2500 ||
      +event.value < minimum
    ) {
      this.formInvalid = true;
    } else {
      this.formInvalid = false;
      this.currentValueSetDonate = event;
      this.changeDonateInput(event);
    }
  }

  changeDonateRadio(event) {
    this.amountChange.emit(event.value);
    this.customRadioDonate = false;
    this.disableBtns = false;
  }

  checkVerifiedEmail() {
    if (!this.storage.user) {
      this.router.navigate([], {
        queryParams: this.authPage('login'),
      });
      return true;
    }
    if (+this.storage.user.is_active === 2) {
      this.toast.error(
        this.translate.instant('AUTH.must_verified_email'),
        this.translate.instant('AUTH.verification_error')
      );
      return true;
    }
    return false;
  }

  navigateToPaymentPayPal(
    donate: number = null
  ) {
    const donationAmount = donate ? donate : this.donation;
    this.router.navigate([
      '/' +
        RoutesPath.default.cart +
        '/' +
        RoutesPath.default.payment_paypal +
        '/' +
        this.projectId +
        '/' +
        donationAmount,
    ]);
  }

  navigateToPaymentTpay() {
    this.router.navigate([
      '/' +
        RoutesPath.default.cart +
        '/' +
        RoutesPath.default.payment_tpay +
        '/' +
        this.projectId +
        '/' +
        this.donation,
    ]);
  }

  currencyChanged(event: UntypedFormControl) {
    this.currencyPicked = event.value;
    const donate = this.form.get('donate');

    if (donate && donate.value === this.initValue) {
      let initValue = 10;
      switch (this.currencyPicked) {
        case 'PLN':
          initValue = 2;
          break;
        case 'USD':
          initValue = 3;
          break;
      }
      this.initValue = initValue;
      this.amountChange.emit(initValue);
      donate.setValue(initValue);
    }
  }

  getRateForCurrency(currency) {
    for (let i = 0; i < this.rates.length; i++) {
      if (this.rates[i].currency === currency) {
        return this.rates[i].rate;
      }
    }
    throw 'Missing currency rate';
  }

  clearCartAndAddOneItem() {
    if (this._facebookPixelService.designatedProjectIds.includes(this.projectId)) {
      this.runFBPixel();
    }

    this.donation = this.form.value.donate ? parseInt(this.form.value.donate) : null;

    if (!this.donation || this.donation === 0) {
      return this.toast.error(
        this.translate.instant('PAYMENT.donate_error_value_to_small'),
        this.translate.instant('PAYMENT.donate_error')
      );
    }

    switch (this.currencyPicked) {
      case "USD":
        this.navigateToPaymentPayPal();
        break;
      case "PLN":
        this.navigateToPaymentTpay();
        break;
      default:
        this.navigateToPaymentPayPal();
    }
  }

  availableOperators() {
    return this.currencyList.filter((el) => {
      return this.isInOperators(el.operator);
    });
  }

  isInOperators(operator: string) {
    if (this.operators) {
      return this.operators.includes(operator);
    }
  }

  addToCart(goToPayment?: boolean) {
    if (this.checkVerifiedEmail()) {
      return false;
    }
    const pack: Donate = {
      amount: this.form.value.donate,
      project_id: this.projectId,
    };
    this.addItem(pack, goToPayment);
  }

  openModal(type: string) {
    switch (type) {
      case 'email-send':
        this.displayContactModal = true;
        break;
    }
  }
}
